export default __webpack_public_path__ + "static/media/vg.f51c5758.svg";